export default __webpack_public_path__ + "static/media/check_circle_outline-24px.b89a6a95.svg";